import { call, put, takeLatest } from "@redux-saga/core/effects";
import Apis from "../../../../api";
import { CommonAction } from "../../../login/redux/types";
import MessageActions from "../../../message/redux/actions";
import DealPaymentActions from "./actions";
import DealPaymentTypes from "./types";

const fetchDealPaymentReq = function* fetchDealPaymentReq(action: CommonAction){
    try {
        const uuid = action.payload;
        const {data} = yield call(Apis.dealPaymentReq, uuid);
        yield put(DealPaymentActions.setDealPaymentReq(data));
    } catch(err) {
        yield put(MessageActions.showMessage({ error: true, text: String(err)}));
        yield put(DealPaymentActions.setDealPaymentReq(undefined));
    }
}

export default function* sagas() {
    yield takeLatest(DealPaymentTypes.DEAL_REPAYMENT_REQ, fetchDealPaymentReq);
}